// 行のコンテキストメニュー非表示項目
export const disabledContextMenuItemsForRow = new Set([
  'gc.spread.contextMenu.insertRows',
  'gc.spread.contextMenu.deleteRows',
  'gc.spread.contextMenu.hideRows',
  'gc.spread.contextMenu.unhideRows',
  'gc.spread.contextMenu.clearContents',
  'rowHeight',
  'contextMenuPaste',
  'contextMenuCut',
  'designerPasteAll',
  'pasteFormula',
  'designerPasteValues',
  'designerPasteFormatting',
  'pasteValuesFormatting',
  'pasteFormulaFormatting',
  'rowHeaders',
  'rowTag',
  'formatCells',
]);

// 列のコンテキストメニュー非表示項目
export const disabledContextMenuItemsForCol = new Set([
  'gc.spread.contextMenu.insertColumns',
  'gc.spread.contextMenu.deleteColumns',
  'gc.spread.contextMenu.hideColumns',
  'gc.spread.contextMenu.unhideColumns',
  'gc.spread.contextMenu.clearContents',
  'columnWidth',
  'contextMenuPaste',
  'contextMenuCut',
  'designerPasteAll',
  'pasteFormula',
  'designerPasteValues',
  'designerPasteFormatting',
  'pasteValuesFormatting',
  'pasteFormulaFormatting',
  'columnHeaders',
  'colTag',
  'formatCells',
  'contextMenuOutlineColumn',
]);

// セルのコンテキストメニュー非表示項目
export const disabledContextMenuItemForCell = new Set([
  'pasteFormula',
  'pasteFormulaFormatting',
  'transformCells',
  'richText',
  'defineName',
  'cellTag',
  'defaultValue',
]);

export const disabledContextMenuItemForSheetTab = new Set([
  'protectSheet',
  'unprotectSheet',
  'sheetTag',
]);

// セルのコンテキストメニューの設定の状態
export const CELL_CONTEXT_MENU_ITEM_STATE = {
  INIT: 0,
  ENABLE_ALL: 1,
  DISABLE_ALL: 2,
} as const;

export type CellContextMenuItemStateType =
  (typeof CELL_CONTEXT_MENU_ITEM_STATE)[keyof typeof CELL_CONTEXT_MENU_ITEM_STATE];
